export const getCollection = (state, collection) => state.resources[collection]
export const getList = (state, collection) => (
  Object.keys(state.resources[collection]).map(
    id => state.resources[collection][id])
)
export const getEntity = (
  state, collection, id) => state.resources[collection]['' + id]